// extracted by mini-css-extract-plugin
export default {"brandPromo":"YE-z","carousel":"ZE-z"};